import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-white" data-testid="login-page">
      <Navbar minimal />
      <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-2">
        <div className="flex items-center justify-center p-10">
          <div className="max-w-md w-full">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-4">
              Sign in · Jingle Hooks
            </div>
            <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter leading-tight mb-4">
              Welcome back. <br />
              Let's make <span className="text-[#FF4500]">noise.</span>
            </h1>
            <p className="text-zinc-600 mb-10">
              Sign in with Google to start generating high-converting jingles in seconds.
            </p>

            <Button
              onClick={handleGoogleLogin}
              className="w-full h-12 bg-black hover:bg-zinc-800 text-white rounded-sm text-base font-semibold flex items-center justify-center gap-3"
              data-testid="google-signin-btn"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 01-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.87 2.68-6.62z" fill="#fff"/>
                <path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.02-3.7H.92v2.33A9 9 0 009 18z" fill="#fff"/>
                <path d="M3.98 10.72A5.4 5.4 0 013.68 9c0-.6.1-1.18.3-1.72V4.95H.92A9 9 0 000 9c0 1.45.35 2.83.92 4.05l3.06-2.33z" fill="#fff"/>
                <path d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 009 0 9 9 0 00.92 4.95l3.06 2.33C4.68 5.16 6.66 3.58 9 3.58z" fill="#fff"/>
              </svg>
              Continue with Google
            </Button>

            <div className="mt-8 text-xs text-zinc-500 font-mono uppercase tracking-widest">
              By signing in you agree to our terms of use.
            </div>
          </div>
        </div>

        <div className="hidden md:block bg-[#09090B] relative overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_reel-hook/artifacts/fsgsog4e_ChatGPT%20Image%20Apr%2025%2C%202026%2C%2001_12_42%20AM.png"
            alt="Sound wave"
            className="absolute inset-0 w-full h-full object-cover opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-transparent to-transparent" />
          <div className="absolute bottom-10 left-10 right-10 text-white">
            <div className="font-mono text-xs uppercase tracking-widest text-[#FF4500] mb-3">
              Built for India
            </div>
            <div className="font-display text-3xl font-semibold leading-tight max-w-md">
              "We shipped our Diwali campaign in under an hour. Game over."
            </div>
            <div className="mt-4 text-sm text-white/60">
              — Priya Kapoor, Head of Growth at Buzzly D2C
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
